import { DatePipe, Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as FileSaver from 'file-saver';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { RadiologyEhr, RadiologyEhrData } from '../../../../@core/interfaces/ehr/radiology-ehr';
import { Physician, PhysicianData } from '../../../../@core/interfaces/masters/physician-mst';
import { NbDateService, NbDialogRef, NbDialogService, NbTabsetComponent } from '@nebular/theme';
import { RolesData } from '../../../../@core/interfaces/common/roles';
import { PatientRegistrationData } from '../../../../@core/interfaces/patient-services/patient-registration';
import { DateService } from '../service/date.service';
import * as period from '../../../../data/period.json';
import * as category from '../../../../data/attachment-category.json';
import * as subCategory from '../../../../data/attachment-sub-category.json';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { UserData } from '../../../../@core/interfaces/common/users';

@Component({
  selector: 'ngx-new-attachment',
  templateUrl: './new-attachment.component.html',
  styleUrls: ['./new-attachment.component.scss']
})

export class NewAttachmentComponent implements OnInit {
  protected readonly unsubscribe$ = new Subject<void>();
  allowClear: boolean = true;
  multiple: boolean = false;
  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  @Input() regId: string="";
  filesDet: RadiologyEhr[];
  dateFilter: RadiologyEhr[];
  phyList: Physician[];
  atchForm: FormGroup;
  term: string;
  p: number = 1;
  isBtnSubmitted = false;
  isSubmitted = false;
  editDet: RadiologyEhr;
  fileToUpload: File = null;
  isImgView: boolean = false;
  srcname: string="";
  rangeDate: Date[];
  max: Date;
  userAccessData: any;
  isView: Boolean = false;
  isEdit: Boolean = false;
  isCreate: Boolean = false;
  isPrint: Boolean = false;
  isShare: Boolean = false;
  isDelete: Boolean = false;
  @Input() fromPatReg;
  @Input() isCategoryFieldReadOnly: boolean = true;
  @Input() patientRegAttach;
  @Input() ehrAttach;
  //should be shared to this component for functionality
  @Input() email: string = "";
  @Input() mobileNumber: string = "";
  @Input() name: string = "";
  @Input() category: string = "";
  @Input() subCategory: string = "";
  @Input() referenceNo: string = "";
  @Input() patient;
  @Input() ehrFlag;
  isconfirmation: boolean = false;
  deleteflag: boolean = false
  @ViewChild("nestedTabRef") tabsetE2: NbTabsetComponent;
  filesizeflag: boolean = false;
  filesize: string;
  smsdto = { "variables": [], "template_id": "", "to": "", "service": "" };
  ApiModel = { "content": "", "toname": "", "toemailid": "", "pagename": "", "subject": "", "branchname": "", "branchcontactnumber": "" };
  categoryOptions = (category as any).default;
  subCategoryOptions = (subCategory as any).default;
  periodList: string[] = (period as any).default;
  storageExceeds: boolean = false;
  storageExceedsErrMsg: boolean = false;
  betweenFlag: boolean;
  period: string;
  attachmentList: Array<any> = [];
  fromDate: string | Date;
  toDate: string | Date;
  iconView: boolean;
  addAttachment: boolean;
  uploadProgress: number;
  doneBy: number = parseInt(localStorage.getItem("userId"));
  subCategorySelected: { categorys: string; subCategory: string; }[];
  userdata: Array<any> = [];
  totalAttachment: Array<any> = [];
  towhatsappnumber: string;
  whatsappcontent: string;
  dialogRef: any;
  resultContent: any;
  @ViewChild('whatsappDialog') whatsappDialog: TemplateRef<any>;
  docType: string;
  vopdFlag: boolean;
  selectDate:boolean=false;

  @Input() showBackIcon:boolean = false;
  @Input() fromMaster:boolean = false;
  @Output() valueUpdateEvent = new EventEmitter<string>();
  @Input() woundCare;

  sourceData:Array<any>=[{id: 1, value: 'Hospital'}, {id: 2, value: 'Patient'}];
  addedBy:string;
  lastAttachmentIcon:string
  
  constructor(protected userService: UserData, private dialogService: NbDialogService, private dateServices: DateService, protected patRegSrvc: PatientRegistrationData, private radiologySrvc: RadiologyEhrData, protected dateService: NbDateService<Date>, protected phySrvc: PhysicianData,
    private fb: FormBuilder, private route: ActivatedRoute, private datePipe: DatePipe, protected rolesService: RolesData,public location: Location) {
    this.route.params.subscribe(params => {
      this.regId = params['regId'];
    });
    this.atchForm = this.fb.group({
      file: this.fb.control(null, [Validators.required]),
      notes: this.fb.control(null),
      // doneby: this.fb.control(null,[Validators.required , Validators.maxLength(25)]),      
      // category: this.fb.control(null, [Validators.required]),     
    });

  }

  ngOnInit(): void {
    this.period = "Today";
    this.searchDet();
    this.fetchUsertype();
    this.userAccessData
    this.fetchPageAccess();
    var x = this.referenceNo;
  }

  startPatientData() {
    this.loadPhy();
    this.searchDet();
    this.fetchPageAccess();
    this.max = this.dateService.addDay(new Date(Date.now()), 0);
    this.getStorageDet();
  }

  vopd(regId){
    this.regId =regId ;
    this.vopdFlag=true;
  }
  
  cancelAddAttachment() {
    this.addAttachment = false;
    this.atchForm.reset();
    this.fileToUpload = null;
    this.uploadProgress = 0;
  }

  send_Email(x: RadiologyEhr) {
    const contentDataURL = "image";
    this.ApiModel.content = contentDataURL;
    this.ApiModel.toname = this.name;
    this.ApiModel.toemailid = this.email;
    this.ApiModel.pagename = "Attachment";
    this.ApiModel.subject = "Attachment";
    this.ApiModel.branchname = x.tenantId;
    this.ApiModel.branchcontactnumber = "9876543210";

    this.patRegSrvc.send_email('patientregistrationmst/' + this.tenantId + '/' + this.branchId + '/' + 'SendNotification', this.ApiModel).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    }, (error) => {
      console.error(error);
    });
  }
  
  send_SMS(x: RadiologyEhr) {
    this.radiologySrvc.create(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/sendsms`, x).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    }, (error) => {
    }, () => {
    });
  }



  send_WTSP(x: RadiologyEhr) {
    this.towhatsappnumber = this.mobileNumber;
    x.isCreate = this.isCreate;
    x.isEdit = this.isEdit;
    x.isView = this.isView;
    this.radiologySrvc.create(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/uri`, x).pipe(takeUntil(this.unsubscribe$)).subscribe((datam: any) => {
      var data = datam;
      this.whatsappcontent = data;
      this.resultContent = `Dear ${this.name}, Please click on the link to view your medical record.` + ' ' + this.whatsappcontent;
      this.dialogRef = this.dialogService.open(
        this.whatsappDialog,
        {
          closeOnBackdropClick: false,
          closeOnEsc: false
        });
    }, (error) => {

    }, () => {

    });

  }

  onCategoryChange() {
    this.subCategorySelected = this.subCategoryOptions.filter(e => e.categorys == this.category);
  }


  goToLink(ref) {
    let encodedContent = encodeURIComponent(this.resultContent);
    window.open('https://web.whatsapp.com/send?phone=91' + this.towhatsappnumber + '&text=' + encodedContent, "_blank");
    this.cancelNotification(ref);
  }
  cancelNotification(ref: NbDialogRef<any>) {
    ref.close();
  }

  TabClick(event) {
    if (event.tabTitle == "Attachments") {
      this.searchDet();
      this.onReset();
    }
  }
  // user role attachment start RAJA 22-11-21
  fetchPageAccess() {
    this.isCreate=true;
    this.isDelete=true;
    this.isEdit=true;
    this.isView=true;
    this.isPrint=true;
    this.isShare=true;
    // if (this.fromPatReg && this.fromPatReg != undefined && this.fromPatReg != null) {
    //   this.userAccessData = this.patientRegAttach;
    //   let View = this.userAccessData.filter(element => access.task.REGATTACH == element.taskID && element.actionID == access.action.VIEW && element.permission == "true");
    //   if (View.length > 0) this.isView = true;
    //   let Create = this.userAccessData.filter(element => access.task.REGATTACH == element.taskID && element.actionID == access.action.CREATE && element.permission == "true");
    //   if (Create.length > 0) this.isCreate = true;
    //   let Edit = this.userAccessData.filter(element => access.task.REGATTACH == element.taskID && element.actionID == access.action.EDIT && element.permission == "true");
    //   if (Edit.length > 0) this.isEdit = true;

    //   let share = this.userAccessData.filter(element => access.task.REGATTACH == element.taskID && element.actionID == access.action.SHARE && element.permission == "true");
    //   if (share.length > 0) this.isShare = true;
    //   let print = this.userAccessData.filter(element => access.task.REGATTACH == element.taskID && element.actionID == access.action.PRINT && element.permission == "true");
    //   if (print.length > 0) this.isPrint = true;

    //   var del = this.userAccessData.filter(element => access.task.REGATTACH == element.taskID && element.actionID == access.action.DELETE && element.permission == "true");
    //   if (del.length > 0) this.isDelete = true;

    // }
    // else {

    //   this.userAccessData = this.ehrAttach;
    //   let View = this.userAccessData.filter(element => access.task.EHROPADVCASESHEET == element.taskID && element.actionID == access.action.VIEW && element.permission == "true");
    //   if (View.length > 0) this.isView = true;
    //   let Create = this.userAccessData.filter(element => access.task.EHROPADVCASESHEET == element.taskID && element.actionID == access.action.CREATE && element.permission == "true");
    //   if (Create.length > 0) this.isCreate = true;
    //   let Edit = this.userAccessData.filter(element => access.task.EHROPADVCASESHEET == element.taskID && element.actionID == access.action.EDIT && element.permission == "true");
    //   if (Edit.length > 0) this.isEdit = true;
    //   let share = this.userAccessData.filter(element => access.task.EHROPADVCASESHEET == element.taskID && element.actionID == access.action.SHARE && element.permission == "true");
    //   if (share.length > 0) this.isShare = true;
    //   let print = this.userAccessData.filter(element => access.task.EHROPADVCASESHEET == element.taskID && element.actionID == access.action.PRINT && element.permission == "true");
    //   if (print.length > 0) this.isPrint = true;
    //   var del = this.userAccessData.filter(element => access.task.EHROPADVCASESHEET == element.taskID && element.actionID == access.action.DELETE && element.permission == "true");
    //   if (del.length > 0) this.isDelete = true;
    // }
  }


  onSearchChange(args: any): void {
      this.attachmentList = this.totalAttachment.filter(x => (x.fileName as string).toLocaleLowerCase().indexOf(this.term.toLocaleLowerCase()) > -1 || x.category.toLocaleLowerCase().indexOf(this.term.toLocaleLowerCase()) > -1 || x.doneBy.toLocaleLowerCase().indexOf(this.term.toLocaleLowerCase()) > -1 || x.category.toLocaleLowerCase().indexOf(this.term.toLocaleLowerCase()) > -1 || x.notes.toLocaleLowerCase().indexOf(this.term.toLocaleLowerCase()) > -1);
  }

  changeDocType(docType:string){
    if(this.docType==undefined || this.docType==""){
      const button = document.getElementById("all");
      button.setAttribute("data-selected", "false");
    }
    if(this.docType!=null && this.docType!="" && this.docType!=undefined){
      const button = document.getElementById(this.docType);
      button.setAttribute("data-selected", "false");
    }
    this.docType=docType;
    const button = document.getElementById(docType);
    button.setAttribute("data-selected", "true");
    if(docType=='all'){
      this.attachmentList = this.totalAttachment;
      return;
    }
    if(docType=='img'){
      this.attachmentList = this.totalAttachment.filter(x => (x.fileName as string).toLocaleLowerCase().indexOf("png") > -1 || (x.fileName as string).toLocaleLowerCase().indexOf("jpeg") > -1 || (x.fileName as string).toLocaleLowerCase().indexOf("jpg") > -1);
      return;
    }
    if(docType=='audio'){
      this.attachmentList = this.totalAttachment.filter(x => (x.fileName as string).toLocaleLowerCase().indexOf("mp3") > -1);
      return;
    }
    if(docType=='document'){
      this.attachmentList = this.totalAttachment.filter(x => (x.fileName as string).toLocaleLowerCase().indexOf("docx") > -1);
      return;
    }
    if(docType=='excel'){
      this.attachmentList = this.totalAttachment.filter(x => (x.fileName as string).toLocaleLowerCase().indexOf("xlsx") > -1);
      return;
    }
    if(docType=='powerPoint'){
      this.attachmentList = this.totalAttachment.filter(x => (x.fileName as string).toLocaleLowerCase().indexOf("pptx") > -1);
      return;
    }
    this.attachmentList = this.totalAttachment.filter(x => (x.fileName as string).toLocaleLowerCase().indexOf(docType.toLocaleLowerCase()) > -1);
  }

  searchDet() {
    if(this.tenantId!=null && this.branchId!=null){
    var method;
    if(this.regId == '00000000-0000-0000-0000-000000000000'){
      method = 'GetUploadedListForMaster';
    }
    else{
      if(this.woundCare || this.ehrFlag){
        method = 'WoundCareAttachmentList'
        if(this.woundCare){const fName = !!this.patient?(this.patient?.patientName?.split(" ")[0]):this.patient?.patientName;
        this.patient.patientName= !!fName?fName:null;}
      }else{
      method = 'GetUploadedList';}
    }
    this.getDateObj();
    let searchData = {
      from: this.fromDate,
      to: this.toDate,
      tenantId: this.tenantId,
      branchId: this.branchId,
      category: this.category,
      subcategory: this.subCategory,
      referenceNo: this.referenceNo,
      searchText: this.term
    }
    const payload = {
    "fromDate": this.fromDate,
    "toDate": this.toDate,
    "tenantId": this.tenantId,
    "category": this.category,
    "firstName": this.name,
    "mobile": this.patient?.patientNumber || this.mobileNumber
    }
    let url = (this.woundCare || this.ehrFlag)?`${this.getApiUrl}/WoundCare/WoundCareAttachmentList`:`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/${method}`
    this.radiologySrvc.create(url, ((this.woundCare || this.ehrFlag)?payload:searchData)).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if(this.woundCare || this.ehrFlag){
        data = data?.details;
        //if(this.woundCare)data = data?.filter(x => x?.referenceNo  == this.referenceNo);
      }
      if (data == null || data?.length == 0) {
        this.attachmentList = [];
      }
      this.attachmentList = data;
      this.totalAttachment = data;
    }, (error) => {
      this.attachmentList = [];
    });
    }

  }

  getDateObj() {
    var date = this.dateServices.currentDate();
    if (this.period != "" && this.period != "Between") {
      switch (this.period) {
        case 'Today':
          this.rangeDate = null;
          this.fromDate = date;
          this.toDate = date;
          break;
        case 'Yesterday':
          date.setDate(date.getDate() - 1);
          this.fromDate = date;
          this.toDate = date;
          break;
        case 'This Week':
          var today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
          this.fromDate = new Date(today.setDate(today.getDate() - today.getDay()));
          this.toDate = date;
          break;
        case 'This Month':
          this.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
          this.toDate = date;
          break;
        case 'This Year':
          this.fromDate = new Date(date.getFullYear(), 0, 1);
          this.toDate = date;
          break;
      }
      this.fromDate = this.dateServices.utcFromDate(this.fromDate);
      this.toDate = this.dateServices.utcToDate(this.toDate);
    } else {
      this.fromDate = this.dateServices.utcFromDate(this.rangeDate[0]);
      this.toDate = this.dateServices.utcToDate(this.rangeDate[1]);
    }
  }

  onReset() {
    this.term = "";
    this.rangeDate = null;
    this.period = "Today";
    this.category = this.ehrFlag?'EHR':this.category;
    this.searchDet();
    this.filesDet = this.filesDet = this.dateFilter?.filter(x => {
      let tempregDate: Date = new Date(x.doneDate);
      return this.dateService.compareDates(new Date(tempregDate.setHours(0, 0, 0, 0)), new Date(this.dateService.today().setHours(0, 0, 0, 0))) == 0;
    });
  }

  loadPhy(): void {
    this.phySrvc.list(`physicians/${this.tenantId}/${this.branchId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.phyList = data.value;
    }, (error) => {
    }, () => {
    });
  }

  calculateDiff(dateSent){
    let currentDate = new Date();
    dateSent = new Date(dateSent);
    return Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate()) ) /(1000 * 60 * 60 * 24));
}

  onPeriodChange(event) {
    if (event.length > 0 && event != undefined) {
      this.betweenFlag = false;
      if (event[0]?.value == "Between") {
        this.betweenFlag = true;
      }
    }
  }

  callEdit(x: RadiologyEhr): void {
    this.editDet = x;
  }

  getUserNameById(id:string){
    let userDet = this.userdata.filter(e=>e.id?.toString()==id);
    return userDet[0]?.firstName;
  }

  download(x: RadiologyEhr): void {
    x.isCreate = this.isCreate;
    x.isEdit = this.isEdit;
    x.isView = this.isView;

    if(!x.visitId){
      x.visitId = null;
    }
    if(!x.regId){
      x.regId = "00000000-0000-0000-0000-000000000000";
    }
    if(!x.regMst){
      x.regMst = null
    }

    this.radiologySrvc.create(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/download`, x).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {


      this.downloadFileRes(data, x.fileName);


    }, (error) => {

    }, () => {

    });



  }
  Delete(x: RadiologyEhr) {
    this.radiologySrvc.delete(`${environment.apiUrl}/AtchDet/${this.tenantId}/${this.branchId}/${x.id}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

    }, (error) => {
    }, () => {
      this.attachmentList = this.attachmentList.filter(data => data.id != x.id);
      this.totalAttachment = this.totalAttachment.filter(data => data.id != x.id)
      this.deleteflag = true
      setTimeout(() => {
        this.deleteflag = false;
      }, 4000);

    });
  }

  view(x: RadiologyEhr): void {
    this.fetchPageAccess();
    x.isCreate = this.isCreate;
    x.isEdit = this.isEdit;
    x.isView = this.isView;

    if(!x.visitId){
      x.visitId = null;
      x.createdBy = null;
    }
    if(!x.regId){
      x.regId = "00000000-0000-0000-0000-000000000000";
    }
    if(!x.regMst){
      x.regMst = null
    }
    

    this.radiologySrvc.create(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/download`, x).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

      if ((x.fileName as string).indexOf(".jpg") > -1 || (x.fileName as string).indexOf(".jpeg") > -1 || (x.fileName as string).indexOf(".png") > -1 || (x.fileName as string).indexOf(".PNG") > -1) {
        this.isImgView = true;
        this.srcname = 'data:image/jpeg;base64,' + data;
      }
      else {
        this.isImgView = false;
        this.downloadFileRes(data, x.fileName);
      }

    }, (error) => {

    }, () => {

    });
  }


  getStorageDet(): void {
    this.phySrvc.list(`AtchDet/${this.tenantId}/${this.branchId}/getStorageSizeForTenant`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      var purchasedGB = data.purchasedGB;
      var usedStorageGB = data.usedGB;
      this.storageExceeds = false;
      // if(purchasedGB - usedStorageGB <= 0){
      //   this.storageExceeds = true;
      // }
    }, (error) => {

    }, () => {
    });
  }

  handleFileInput(files: any) {
    if (!this.storageExceeds) {
      this.filesizeflag = false;
      this.storageExceedsErrMsg = false;
      let sizeInBytes: number = files.currentTarget.files[0].size;
      this.bytesToSize(sizeInBytes);
      if (files.currentTarget.files.length > 0) {
        this.fileToUpload = files.currentTarget.files[0];
      }
    }
    else {
      this.storageExceedsErrMsg = true;
    }
  }
  
  bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    let i = Number(Math.floor(Math.log(bytes) / Math.log(1024)));
    this.filesize = Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
    var fs = Math.round(bytes / Math.pow(1024, i));
    var kb = Math.round(Number(bytes / 1024) - Number(Math.round(bytes / Math.pow(1024, i)) * 1024))
    if (fs > 50 && i > 1) {
      this.filesizeflag = true;

    }
    return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
  }

  onSave(): void {
    this.isSubmitted = true;
    this.isBtnSubmitted = true;
    if (this.atchForm.invalid) {
      this.isBtnSubmitted = false;
      return;
    }
    const formData: FormData = new FormData();
    formData.append('fileKey', this.fileToUpload, this.fileToUpload.name);
    let fileLoc=""
    if(this.category=="Billing"){
      let fileName=this.name+"_Billing_"+this.referenceNo;
      fileLoc = `${this.tenantId}/${this.branchId}/${this.regId}/${this.category}/${fileName}`
    }
    else{
      fileLoc = `${this.tenantId}/${this.branchId}/${this.category}/${this.referenceNo}/${this.fileToUpload.name}`
    }
    let postData: any = {
      regId: this.regId,
      tenantId: this.tenantId,
      branchId: this.branchId,
      containerName: this.tenantId,
      fileLocation: fileLoc,
      fileName: this.fileToUpload.name,
      category: this.category,
      doneDate: this.dateServices.currentDate(),
      doneBy: this.doneBy,
      fileAddedBy: this.addedBy,
      subcategory: this.subCategory,
      notes: this.atchForm.get("notes").value,
      referenceNo: this.referenceNo,
      tagType: "none",
      fileAddedFrom: this.category,
      isEdit: this.isEdit,
      isCreate: this.isCreate,
      createdBy: this.doneBy
    }

    for (const prop in postData) {
      if (!postData.hasOwnProperty(prop)) { continue; }
      formData.append(prop, postData[prop]);
    }

    this.radiologySrvc.createWithProgress(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/attachDoc`, formData).pipe(
      map((event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            const progress = Math.round((100 * event.loaded) / (event.total || 1));
            return { progress }; // Only return progress until the response is available

          case HttpEventType.Response:
            return { progress: 100, response: event.body }; // Return the final response with 100% progress

          default:
            return { progress: 0 };
        }
      })).pipe(takeUntil(this.unsubscribe$)).subscribe(({ progress, response }) => {
        this.uploadProgress = progress;
        if (response) {
          this.uploadProgress = 0;
          this.searchDet();
        }
      }, (error) => {
        this.isBtnSubmitted = false;
      }, () => {
        this.changeDocType('all')
        this.isconfirmation = true;
        setTimeout(() => {
          this.isconfirmation = false;
        }, 4000);

        this.onClear();
      });
  }

  get fval() { return this.atchForm.controls; }


  onClear(): void {
    this.isBtnSubmitted = false;
    this.isSubmitted = false;
    this.filesizeflag = false;
    this.storageExceedsErrMsg = false;
    this.atchForm.reset();
  }

  fetchUsertype() {
    this.userService.userList(`users/userlist/${this.tenantId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.userdata = data;
      this.doneBy = parseInt(localStorage.getItem("userId"));
    }, (error) => {
    }, () => {
    });
  }

  downloadFileRes(data: any, filename: string) {

    var binary_string = window.atob(data);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    var byteArray = bytes.buffer;

    if (filename.indexOf(".pdf") > -1) {
      var blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    }
    else {
      var blob = new Blob([byteArray]);
      FileSaver.saveAs(blob, filename, true);
    }

  }
  get getApiUrl(): string {
    return environment.apiUrl;
  }

  goBack(){
    this.valueUpdateEvent.emit();
  }

  getFileIcon(fileName){
    const ext = fileName.split('.').pop()?.toLocaleLowerCase();
    if (!fileName) {
      return 'assets/images/empty/app/pdf.svg';
    }
    const iconMap: { [key: string]: string } = {
      'pdf': 'assets/images/empty/app/pdf.svg',
      'doc': 'assets/images/empty/app/word_16x1.svg',
      'docx': 'assets/images/empty/app/word_16x1.svg',
      'odt': 'assets/images/empty/app/word_16x1.svg',
      'xls': 'assets/images/empty/app/excel_16x1.svg',
      'xlsx': 'assets/images/empty/app/excel_16x1.svg',
      'jpg': 'assets/images/empty/app/pngImage.png',
      'jpeg': 'assets/images/empty/app/pngImage.png',
      'png': 'assets/images/empty/app/pngImage.png',
      'txt': 'assets/images/empty/app/word_16x1.svg',
      'ppt': 'assets/images/empty/app/powerpoint_16x1.svg',
      'pptx': 'assets/images/empty/app/powerpoint_16x1.svg'
    };

    return iconMap[ext] || '../.././../../assets/images/empty/app/pdf.svg';
  }
}
